import {getCurrentAuthSelector, getCurrentCustomerSelector, getCurrentServerConfig} from '../selectors';

export const pusherConnectionUpdaterMiddleware = store => next => action => {
	const state = store.getState();
	const currentServerConfig = getCurrentServerConfig(state);
	const currentCustomer = getCurrentCustomerSelector(state);
	const currentAuthData = getCurrentAuthSelector(state);

	const restaurantId = currentCustomer && currentCustomer.restaurant && currentCustomer.restaurant.restaurantId;
	const udid = currentAuthData && currentAuthData.udid;

	if (!currentServerConfig) {
		return next(action);
	}

	import('managers/pusher.manager.js').then(({default: Pusher}) => {
		window.__pusher = Pusher;

		if (
			Pusher.isDisconnected() ||
			Pusher.isOutdated(currentServerConfig.pusherKey, currentServerConfig.pusherCluster)
		) {
			Pusher.recreate(currentServerConfig.pusherKey, currentServerConfig.pusherCluster);
			if (restaurantId) {
				Pusher.recreateRestaurantChannel(restaurantId, store.dispatch);
			}
			if (udid) {
				Pusher.recreateCustomerChannel(currentAuthData.udid, store.dispatch);
			}
			return;
		}

		if (udid) {
			if (Pusher.isCustomerChannelOutdated(udid)) {
				Pusher.recreateCustomerChannel(udid, store.dispatch);
			}
		} else {
			Pusher.deleteCustomerChannel();
		}

		if (restaurantId) {
			if (Pusher.isRestaurantChannelOutdated(restaurantId)) {
				Pusher.recreateRestaurantChannel(restaurantId, store.dispatch);
			}
		} else {
			Pusher.deleteRestaurantChannel();
		}
	});

	return next(action);
};
